import { WorldInstance } from './src/feature/world/world';
export { narrators, world, worldConfig } from './game/demo';

new WorldInstance();
